/*
  Splash / entry page.

  The overlay is a plain <a> that navigates on click — it needs no JavaScript,
  and works with no video and no image. This script only handles video
  playback: start it muted, and never autoplay it for visitors who have asked
  for reduced motion (they get the poster / first frame instead).
*/

class SplashEntry extends HTMLElement {
  connectedCallback() {
    const video = this.querySelector('.splash-entry__video');
    if (!video) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      try {
        video.pause();
      } catch (e) {}
      return;
    }

    video.muted = true;
    const played = video.play();
    if (played && typeof played.catch === 'function') {
      // Autoplay can still be refused (low-power mode, data saver); the poster
      // stays visible, which is an acceptable fallback.
      played.catch(() => {});
    }
  }
}

customElements.define('splash-entry', SplashEntry);
